import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { colourStyles } from 'utils/selectStyle'

const CustomMissionSelect = ({ onChange, token, translate, value }) => {
  const [missions, setMissions] = useState([])
  const [loading, setLoading] = useState(false)

  const mapMissions = (mission) => ({
    value: mission.cdMission,
    label: mission.dsMission,
  })

  useEffect(() => {
    const fetchMissions = async () => {
      setLoading(true)

      await new Api(token)
        .get(API_URL.MISSION_LIST)
        .then((response) => setMissions(response.data.map(mapMissions)))
        .catch(() => setMissions({ missions: [] }))
        .finally(() => setLoading(false))
    }

    fetchMissions()
  }, [])

  return (
    <Select
      className='custom-select'
      classNamePrefix='custom-select'
      isClearable
      onChange={(option) => onChange(option ? option.value : null)}
      options={missions}
      placeholder={translate(
        loading ? 'mission-edit.loading' : 'mission-edit.choose-mission'
      )}
      styles={colourStyles}
      value={
        missions && value
          ? missions.find((option) => option.value === value)
          : null
      }
    />
  )
}

CustomMissionSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  token: PropTypes.string,
  translate: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default CustomMissionSelect
